module.exports = __webpack_public_path__ + "img/bleeding-edge-forum.a468e182.jpg";